export class GrupoProdutoCulturaCentroCusto {
    Id: number;
    GrupoProdutoId:number = 0;
    CulturaId:number;
    CentroCustoERP:string = "";
    Irrigado: boolean;
    FlagSemente: boolean;
}
